import React, { useState, useRef, useEffect } from "react";
import ReactMarkdown from "react-markdown"; // <-- Para renderizar Markdown
import robotImg from "../assets/robot.png";
import "./ChatBox.css";
import remarkGfm from "remark-gfm";
function ChatBox({ sendMessage, userName, handleUserName, selectedOption, goBack }) {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [typing, setTyping] = useState(false);
  const messagesEndRef = useRef(null);
  const shouldAutoScroll = useRef(false);

  // Mensaje inicial con animación de typing
useEffect(() => {
  if (!userName) {
    setTyping(true);
    setTimeout(() => {
      setMessages([
        {
          sender: "robot",
          text: "Hi! I'm FinSight 🤖. Before we begin, what's your name?"
        }
      ]);
      setTyping(false);
    }, 600);
  } else {
    setMessages([
      {
        sender: "robot",
        text: `Welcome back, **${userName}** 👋\n\n${getMessageByOption()}`
      }
    ]);
  }
}, [selectedOption]);

useEffect(() => {
  if (shouldAutoScroll.current) {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    shouldAutoScroll.current = false;
  }
}, [messages]);

  // Mensaje inicial según la opción seleccionada
  const getMessageByOption = () => {
    switch (selectedOption) {
      case "concepts":
        return "What do you want to learn about finance?";
      case "budget":
        return "Tell me about your idea of a budget";
      default:
        return "What do you want to do?";
    }
  };



  const handleSend = async () => {
    if (!input.trim()) return;

    const currentInput = input.trim();
    setInput("");

    // Si aún no tenemos nombre → este primer mensaje será el nombre
    if (!userName) {
      handleUserName(currentInput);

      setMessages(prev => [
        ...prev,
        {
          sender: "robot",
          text: `Great, ${currentInput}! ${getMessageByOption()}`
        }
      ]);
      return;
    }

    // Mensaje del usuario
    shouldAutoScroll.current = true;
setMessages(prev => [...prev, { sender: "user", text: currentInput }]);
    try {
      setTyping(true);
      const answer = await sendMessage(currentInput);

     setTimeout(() => {
  shouldAutoScroll.current = true;
  setMessages(prev => [...prev, { sender: "robot", text: answer }]);
  setTyping(false);
}, 600);
    } catch (err) {
      setMessages(prev => [
        ...prev,
        { sender: "robot", text: "An error occurred while processing your message." }
      ]);
      setTyping(false);
      console.error(err);
    }
  };

  return (
    <div className="chat-box">
  {/* Botón para volver al menú */}
  <button className="back-button" onClick={goBack}>
    Menu
  </button>
      <div className="messages">
        {messages.map((msg, idx) => (
        <div key={idx} className={msg.sender === "user" ? "user-msg" : "robot-msg"}>
  {msg.sender === "robot" && (
    <img src={robotImg} alt="robot" className="robot-icon" />
  )}
{msg.sender === "robot" ? (
  <div className="markdown-content">
   <ReactMarkdown remarkPlugins={[remarkGfm]}>
  {msg.text}
</ReactMarkdown>
  </div>
) : (
  <span>{msg.text}</span>
)}

</div>
        ))}

        {/* Burbuja de typing */}
        {typing && (
          <div className="robot-msg">
            <img src={robotImg} alt="robot" className="robot-icon" />
            <div className="typing-animation">
              <span></span><span></span><span></span>
            </div>
          </div>
        )}

        <div ref={messagesEndRef} />
      </div>

      <div className="chat-input">
        <input
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleSend()}
          placeholder="Type your message..."
        />
        <button onClick={handleSend}>Send</button>
      </div>
    </div>
  );
}

export default ChatBox;
